(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[59115],{

/***/ 59115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ FAQ; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/bestpostagemeters/faq/questions.ts
const questions = [
    {
        title: "What is metered mail?",
        description: "Metered mail is postage that does not need a traditional postage stamp as it is already paid in advance. A stamped ink marks proof of postage payment instead of a postage meter."
    },
    {
        title: "Can I own a postage meter?",
        description: "Postage meters are used to print First-Class postage and other USPS services in the U.S that cannot be purchased by an individual or a business. This is because postage is considered a form of currency that needs regulation, like a money printing press."
    },
    {
        title: "How can a postage meter help my business?",
        description: "Postage meters give your business access to discounted postage from the convenience of your office, thus saving you time and money. Such USPS postage rates can save you up to 5 cents on every First-Class letter sent and up to 30% off USPS Priority Mail Postage."
    },
    {
        title: "What is a preferred postage rate?",
        description: "High-volume mailers are provided with 'bulk discount postage' and discounted postage for Priority Mail with a preferred rate, saving your business a significant amount of money over time. Preferred rates are best suited for businesses that ship large quantities of mail through the USPS."
    }, 
];
/* harmony default export */ var faq_questions = (questions);

// EXTERNAL MODULE: ./src/components/shared/featureList/index.tsx
var featureList = __webpack_require__(73367);
;// CONCATENATED MODULE: ./src/components/bestpostagemeters/faq/index.tsx



function FAQ() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(featureList/* default */.Z, {
        featureList: faq_questions,
        mainTitle: "Frequently asked questions about postage meter machines",
        classes: {
            mainSectionClasses: "flex flex-col hover:max-w-7xl mx-auto px-4vw lg:px-4 my-10 md:my-32",
            mainTitleClasses: "font-bold capitalize mb-12 md:w-9/12 mx-auto md:mb-20 text-2xl text-center  md:text-4xl",
            innerSectionClasses: "grid grid-cols-1 md:grid-cols-2 gap-16",
            titleClasses: "text-xl md:text-2xl mb-2 font-semibold",
            descriptionClasses: "text-base md:text-xl font-light",
            oneBoxClasses: " "
        },
        colors: {
            descriptionColor: "#676767"
        }
    });
}


/***/ }),

/***/ 73367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FeatureList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35533);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39717);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);







function FeatureList({ featureList , mainTitle , mainDescription , colors , classes  }) {
    const outerSectionStyle = {
        "--bg": `${colors?.bgColor ?? "transparent"}`,
        "--iconColor": `${colors?.iconColor ?? "gray"}`
    };
    const { query  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        style: outerSectionStyle,
        className: `mt-10 lg:mt-16 ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().mainSection)} `,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classes?.mainSectionClasses ?? "",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    style: {
                        color: colors?.mainTitleColor ?? "black"
                    },
                    className: classes?.mainTitleClasses ?? "text-center text-xl lg:text-2xl mb-14",
                    children: mainTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    style: {
                        color: colors?.mainDescriptionColor ?? "black"
                    },
                    className: classes?.mainDescriptionClasses ?? "",
                    children: mainDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes?.innerSectionClasses ?? "lg:flex flex-wrap justify-center",
                    children: featureList?.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classes?.oneBoxClasses ? `${classes?.oneBoxClasses} ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""}` : `text-center mb-12 lg:mb-20 w-full lg:w-1/3   ${colors?.iconColor ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().item) : ""} `,
                            children: [
                                item.path ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classes?.iconClasses ?? "relative mb-14 w-[190px] h-[190px]  mx-auto",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: item.path,
                                        layout: "fill",
                                        alt: item.title
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: classes?.iconClasses ?? "children:w-12 children:h-12 children:mx-auto ",
                                    children: item.icon
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    style: {
                                        color: colors?.titleColor ?? "black"
                                    },
                                    className: classes?.titleClasses ?? "font-medium text-lg lg:text-xl mt-6",
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        color: colors?.descriptionColor ?? "black"
                                    },
                                    className: classes?.descriptionClasses ?? "font-light text-sm text-center w-4/5 mx-auto mt-2",
                                    children: item.description
                                }),
                                item.tool && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: `/tools/${item.tool}?${(0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start")}`,
                                    className: classes?.toolClasses ? `${classes?.toolClasses} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}` : `mt-4 flex gap-2 items-center md:mt-auto ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)}`,
                                    style: {
                                        color: colors?.toolColor ?? "black"
                                    },
                                    children: [
                                        "Details",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_svg_chevron__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            className: "transform rotate-180",
                                            fill: colors?.chevronColor
                                        })
                                    ]
                                })
                            ]
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 39717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Chevron; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Chevron({ className , fill  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "8",
        height: "12",
        viewBox: "0 0 8 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.4 1.4L6 0L0 6L6 12L7.4 10.6L2.8 6L7.4 1.4Z",
            fill: fill ?? "black"
        })
    });
}


/***/ }),

/***/ 35533:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","item":"styles_item__j6_jF","mainSection":"styles_mainSection__2nFt8","link":"styles_link___4DQd"};

/***/ })

}]);